import React from 'react';
import { motion } from 'framer-motion';
export function MomentsSection() {
  return <section id="experiencias" className="bg-cream px-6 sm:px-8 lg:px-12 py-20 md:py-28" data-id="element-337" data-mp="i934obqwkmnr">
      <div className="max-w-[1400px] mx-auto" data-id="element-338" data-mp="d9gobtfs2qaq">
        <motion.div initial={{
        opacity: 0,
        y: 35
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-339" data-mp="dai3oa3ttyy9">
          <span className="inline-block text-[0.67rem] font-semibold tracking-[0.3em] uppercase text-forest-500 mb-5" data-id="element-340" data-mp="10zksc1wvos29">
            Momentos Únicos
          </span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.15] text-night" data-id="element-341" data-mp="w6rpjjkyztst">
            Momentos que<br data-id="element-342" data-mp="1oovjqssc9a3q" />
            <em className="italic text-forest-500" data-id="element-343" data-mp="1opf38dxn06jv">no se olvidan</em>
          </h2>
          <p className="text-sm leading-[1.8] text-black/50 max-w-xl mx-auto mt-4" data-id="element-344" data-mp="1jy6uzl81mr8a">
            El lujo real no se compra. Se vive. Cada instante aquí es una historia que querrás contar.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 mb-5" data-id="element-345" data-mp="n0xg8l2z40ae">
          <motion.div initial={{
          opacity: 0,
          y: 35
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.8,
          delay: 0.1
        }} className="group relative rounded-3xl overflow-hidden cursor-pointer transition-transform duration-500 hover:scale-[1.015] h-[320px] sm:h-[420px] lg:h-[640px]" data-id="element-346" data-mp="n28nwvzjhs6s">
            <img src="https://i.imgur.com/908kujZ.jpeg" alt="Piscina principal desde el aire" className="w-full h-full object-cover transition-transform duration-[800ms] group-hover:scale-[1.07]" data-id="element-347" data-mp="3li1h7dsvs3ed" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 to-transparent to-55%" data-id="element-348" data-mp="1jqn7dgc59zyw" />
            <div className="absolute bottom-0 left-0 right-0 p-7" data-id="element-349" data-mp="1oprkuj63qjv1">
              <h3 className="font-display text-3xl lg:text-[2.1rem] font-light text-white mb-1" data-id="element-350" data-mp="1ooyhls6cqchn">La Piscina desde las Alturas</h3>
              <p className="text-[0.7rem] text-gold-light tracking-[0.1em] uppercase" data-id="element-351" data-mp="1i9hkxga29167">Flotando entre montañas · Sensación única</p>
            </div>
          </motion.div>

          <div className="flex flex-col gap-5" data-id="element-352" data-mp="1daoeg7t6yafj">
            <motion.div initial={{
            opacity: 0,
            y: 35
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="group relative rounded-3xl overflow-hidden cursor-pointer transition-transform duration-500 hover:scale-[1.015] flex-1 min-h-[200px] sm:min-h-[180px] lg:min-h-[200px]" data-id="element-353" data-mp="199bdoc4ygxfh">
              <img src="https://i.imgur.com/WGxCybn.png" alt="Noche estrellada luna y cabaña" className="w-full h-full object-cover transition-transform duration-[800ms] group-hover:scale-[1.07]" data-id="element-354" data-mp="1s7f6fw0jcjv4" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 to-transparent to-55%" data-id="element-355" data-mp="2jxjzsk69wh8h" />
              <div className="absolute bottom-0 left-0 right-0 p-7" data-id="element-356" data-mp="6i1pofbrbern">
                <h3 className="font-display text-2xl font-light text-white mb-1" data-id="element-357" data-mp="bgbl8r1e8hds">Noches bajo la Luna</h3>
                <p className="text-[0.7rem] text-gold-light tracking-[0.1em] uppercase" data-id="element-358" data-mp="fg3yvi5n9dq0">Magia nocturna · Estrellas y silencio</p>
              </div>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 35
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.8,
            delay: 0.3
          }} className="group relative rounded-3xl overflow-hidden cursor-pointer transition-transform duration-500 hover:scale-[1.015] flex-1 min-h-[200px] sm:min-h-[180px] lg:min-h-[200px]" data-id="element-359" data-mp="pfl5c1spzvn1">
              <img src="https://i.imgur.com/Hqp9O9L.jpeg" alt="El Jacuzzi del Paraíso" className="w-full h-full object-cover transition-transform duration-[800ms] group-hover:scale-[1.07]" data-id="element-360" data-mp="18746e336ozmf" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/75 to-transparent to-55%" data-id="element-361" data-mp="zgm0q4x1lvbp" />
              <div className="absolute bottom-0 left-0 right-0 p-7" data-id="element-362" data-mp="uiat80u7zwwn">
                <h3 className="font-display text-2xl font-light text-white mb-1" data-id="element-363" data-mp="197zyo89cin2q">El Jacuzzi del Paraíso</h3>
                <p className="text-[0.7rem] text-gold-light tracking-[0.1em] uppercase" data-id="element-364" data-mp="149omvrzhq2hv">Naturaleza y agua · Lujo al aire libre</p>
              </div>
            </motion.div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 lg:h-[280px]" data-id="element-365" data-mp="bl188f98ybda">
          <motion.div initial={{
          opacity: 0,
          y: 35
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.8,
          delay: 0.1
        }} className="group relative rounded-3xl overflow-hidden cursor-pointer transition-transform duration-500 hover:scale-[1.015] h-[220px] md:h-auto" data-id="element-366" data-mp="qhrzu2coiisc">
            <img src="https://i.imgur.com/Z72cnCj.jpeg" alt="Desayuno con Vista" className="w-full h-full object-cover transition-transform duration-[800ms] group-hover:scale-[1.07]" data-id="element-367" data-mp="24h3lol9zwed3" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 to-transparent to-55%" data-id="element-368" data-mp="1vg5drrwfrmp8" />
            <div className="absolute bottom-0 left-0 right-0 p-7" data-id="element-369" data-mp="1zhqz81n1d9b1">
              <h3 className="font-display text-2xl font-light text-white mb-1" data-id="element-370" data-mp="1zi0n9joit6e3">Desayuno con Vista</h3>
              <p className="text-[0.7rem] text-gold-light tracking-[0.1em] uppercase" data-id="element-371" data-mp="2n83anmhhpo6d">El ritual de la mañana · Naturaleza al fondo</p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 35
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="group relative rounded-3xl overflow-hidden cursor-pointer transition-transform duration-500 hover:scale-[1.015] h-[220px] md:h-auto" data-id="element-372" data-mp="2ee86ago701rs">
            <img src="https://i.imgur.com/rEeOBSk.jpeg" alt="El Refugio del Amor" className="w-full h-full object-cover transition-transform duration-[800ms] group-hover:scale-[1.07]" data-id="element-373" data-mp="3kruwxi55xrhj" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/75 to-transparent to-55%" data-id="element-374" data-mp="3brew6gft0ygd" />
            <div className="absolute bottom-0 left-0 right-0 p-7" data-id="element-375" data-mp="36twhe9f3vp0g">
              <h3 className="font-display text-2xl font-light text-white mb-1" data-id="element-376" data-mp="31u0g4hxsmbol">El Refugio del Amor</h3>
              <p className="text-[0.7rem] text-gold-light tracking-[0.1em] uppercase" data-id="element-377" data-mp="2x3bkqrizsuk6">Parejas · Momentos íntimos · Magia</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}